import Pagination from "./Pagination";
import React, { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useHistory, useLocation, Link } from "react-router-dom";
import { TokenContext } from "./TokenContext";
import Repo from "../Utility/Repo";
import ModalComponent from "./ModalComponent";
import Badge from "./Badge";
import UserDataComponent from "./UserDataComponent";
import IO from "../Assets/Img/IO.svg";

const ListPaymemtsUsers = (props) => {
  const [showFileToggle, toggleModalShowFile] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [showModalMail, setShowModalMail] = useState(false);
  const [showModalIO, setShowModalIO] = useState(false);
  const [showModalCustomPayment, setShowModalCustomPayment] = useState(false);
  const [selectedIUV, setSelectedIUV] = useState("");
  const apiToken = useContext(TokenContext);
  const [file, setFile] = useState();
  const [hasMail, setHasMail] = useState(false);
  const [customPaymentLoading, setCustomPaymentLoading] = useState(false);
  const [customPayment, setCustomPayment] = useState({
    announcementId: "",
    importo: "",
    descrizione: "",
  });

  let history = useHistory();
  const { operator, userData, delegate, user, citizen } = UserDataComponent();

  const [formData, setFormData] = useState({
    iuv: "", // Se id esiste, assegnalo a formData.iuv, altrimenti assegna una stringa vuota
    descrizione: "",
    valore: 0,
    inviaEmail: true,
  });

  const isMobile = () =>
    /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent);

  const [error, setError] = useState("");

  const toggleModalDetail = () => {
    setShowModalDetail(!showModalDetail);
    // Azzeramento dei campi qui
    setFormData({
      iuv: "", // Assegna il valore di id se disponibile, altrimenti stringa vuota
      descrizione: "",
      valore: 0, // Reset valore
      inviaEmail: true,
    });
    setError("");
  };

  const toggleModalMail = () => {
    setShowModalMail(!showModalMail);
    // Azzeramento dei campi qui
    setError("");
  };

  const toggleModalIO = () => {
    setShowModalIO(!showModalIO);
    // Azzeramento dei campi qui
    setError("");
  };

  const showPayments = (id) => {
    if (isMobile()) {
      showPaymentsMobile(id);
      return;
    }

    Repo.getIuvUser(apiToken, id, true)
      .then((response) => {
        if (response.status === 200) {
          setFile();
          const obj = document.createElement("object");
          obj.type = "application/pdf";
          obj.data = "data:application/pdf;base64," + response.data;
          setFile(obj);
          toggleModalShowFile(!showFileToggle);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const showPaymentsMobile = (id) => {
    Repo.getIuvUser(apiToken, id, true)
      .then((response) => {
        if (response.status === 200) {
          const byteCharacters = atob(response.data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);

          // Apri una nuova finestra o tab (su mobile può aprirsi nel visualizzatore PDF di default)
          window.open(blobUrl, "_blank");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const refreshPayments = () => {
    if (typeof props.onRefreshPayments === "function") {
      return props.onRefreshPayments();
    }
    return Promise.resolve();
  };

  const handleSaveSendMail = () => {
    Repo.postSendEmail(apiToken, selectedIUV, props.userId)
      .then(async (response) => {
        if (response.status == 200) {
          setShowModalMail(false);
          setSelectedIUV("");
          await refreshPayments();
        }
      })
      .catch((error) => {
        setError(error.response?.data?.Message || error.response?.data || "");
      });
    setError("");
  };

  const handleSaveSendIO = () => {
    Repo.postSendIO(apiToken, selectedIUV, props.userId)
      .then(async (response) => {
        if (response.status == 200) {
          setShowModalIO(false);
          setSelectedIUV("");
          await refreshPayments();
        }
      })
      .catch((error) => {
        setError(error.response?.data?.Message || error.response?.data || "");
      });
    setError("");
  };

  const eligibleSubscriptions = (() => {
    const seen = new Set();
    const list = [];
    for (const s of props.subscriptions || []) {
      if (!s?.announcement?.id) continue;
      const annId = s.announcement.id;
      if (seen.has(annId)) continue;
      seen.add(annId);
      list.push(s);
    }
    return list;
  })();

  const canCreateCustomPayment = eligibleSubscriptions.length > 0;

  const parsedCustomImporto = parseFloat(
    String(customPayment.importo).replace(",", "."),
  );
  const customDescrizioneLen = (customPayment.descrizione || "").trim().length;
  const isCustomPaymentFormValid =
    canCreateCustomPayment &&
    !!customPayment.announcementId &&
    Number.isFinite(parsedCustomImporto) &&
    parsedCustomImporto > 1 &&
    customDescrizioneLen >= 10 &&
    customDescrizioneLen <= 64;

  const openCustomPaymentModal = () => {
    setError("");
    setCustomPayment({
      announcementId: "",
      importo: "",
      descrizione: "",
    });
    setShowModalCustomPayment(true);
  };

  const closeCustomPaymentModal = () => {
    setShowModalCustomPayment(false);
    setError("");
    setCustomPayment({
      announcementId: "",
      importo: "",
      descrizione: "",
    });
  };

  const handleSaveCustomPayment = () => {
    if (customPaymentLoading || !isCustomPaymentFormValid) return;
    if (!props.userId) {
      setError("Utente non valido.");
      return;
    }
    const importo = parsedCustomImporto;

    setCustomPaymentLoading(true);
    setError("");
    Repo.postPagamentoPersonalizzato(apiToken, {
      announcementId: customPayment.announcementId,
      userId: props.userId,
      importo,
      descrizione: customPayment.descrizione.trim(),
    })
      .then(async (response) => {
        if (response.status === 200) {
          closeCustomPaymentModal();
          await refreshPayments();
        }
      })
      .catch((error) => {
        setError(
          error.response?.data?.Message ||
            error.response?.data ||
            "Errore durante la creazione del pagamento.",
        );
      })
      .finally(() => {
        setCustomPaymentLoading(false);
      });
  };

  const bodyCustomPayment = () => (
    <>
      <p className="text-muted mb-3">
        Crea un pagamento MyPay personalizzato usando i dati contabili del
        bando selezionato (codice accertamento, capitolo, nome MyPay).
      </p>
      {!canCreateCustomPayment && (
        <div className="alert alert-warning" role="alert">
          Nessuna iscrizione a un bando disponibile per questo cittadino. Non
          è possibile creare un pagamento personalizzato.
        </div>
      )}
      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}
      <div className="mb-3">
        <label htmlFor="customAnnouncement" className="d-block mb-2">
          Bando*
        </label>
        <select
          id="customAnnouncement"
          className="form-control w-100"
          style={{ minHeight: "2.75rem" }}
          value={customPayment.announcementId}
          disabled={!canCreateCustomPayment || customPaymentLoading}
          onChange={(e) =>
            setCustomPayment({
              ...customPayment,
              announcementId: e.target.value,
            })
          }
        >
          <option value="">
            {canCreateCustomPayment
              ? "Seleziona bando..."
              : "Nessun bando disponibile"}
          </option>
          {eligibleSubscriptions.map((s) => (
            <option key={s.announcement.id} value={s.announcement.id}>
              {s.announcement.name}
              {s.announcement.service?.name
                ? ` — ${s.announcement.service.name}`
                : ""}
            </option>
          ))}
        </select>
      </div>
      <div className="mb-3">
        <label htmlFor="customImporto" className="d-block mb-2">
          Importo (€)* (maggiore di 1 €)
        </label>
        <input
          id="customImporto"
          type="number"
          min="1.01"
          step="0.01"
          className="form-control"
          value={customPayment.importo}
          disabled={!canCreateCustomPayment || customPaymentLoading}
          onChange={(e) =>
            setCustomPayment({ ...customPayment, importo: e.target.value })
          }
        />
      </div>
      <div className="mb-3">
        <label htmlFor="customDescrizione" className="d-block mb-2">
          Descrizione / causale* (min 10, max 64 caratteri)
        </label>
        <textarea
          id="customDescrizione"
          className="form-control"
          rows={3}
          maxLength={64}
          value={customPayment.descrizione}
          disabled={!canCreateCustomPayment || customPaymentLoading}
          onChange={(e) =>
            setCustomPayment({
              ...customPayment,
              descrizione: e.target.value,
            })
          }
        />
        <small className="form-text text-muted">
          {customDescrizioneLen}/64 caratteri
          {customDescrizioneLen > 0 && customDescrizioneLen < 10
            ? " — minimo 10"
            : ""}
        </small>
      </div>
    </>
  );

  const handleSave = () => {
    //alert(formData.Iuv);
    // Effettua la validazione dei dati
    if (!formData.descrizione) {
      setError("Il campo descrizione è obbligatorio!");
      return;
    }

    if (formData.descrizione.length > 300) {
      setError("Il campo Descrizione deve essere massimo 300 caratteri!");
      return;
    }

    setFormData({
      iuv: selectedIUV,
      descrizione: formData.descrizione,
      valore: formData.valore,
      inviaEmail: formData.inviaEmail !== false,
    });
    console.log(formData.descrizione + "iuv:" + selectedIUV);
    const data = {
      iuv: selectedIUV,
      descrizione: formData.descrizione,
      valore: formData.valore,
      inviaEmail: formData.inviaEmail !== false,
    };

    Repo.poutUpdatePaidOp(apiToken, data)
      .then(async (response) => {
        if (response.status == 200) {
          setShowModalDetail(false);
          setSelectedIUV("");
          await refreshPayments();
        }
      })
      .catch((error) => {
        setError(error.response?.data?.Message || error.response?.data || "");
      });

    // Resetta i valori del form dopo il salvataggio
    setFormData({
      iuv: "",
      descrizione: "",
      valore: 0,
      inviaEmail: true,
    });

    // Resetta l'errore
    setError("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "valore" ? value : value, // Mantieni "valore" come stringa
    }));
  };

  const bodyFile = () => {
    return (
      <object
        width="100%"
        height="900"
        data={file && file.data}
        type={file && file.type}
      ></object>
    );
  };

  const showDetail = (id) => {
    setSelectedIUV(id);
    setShowModalDetail(true);
  };

  const sendPayments = (id) => {
    setSelectedIUV(id);
    setShowModalMail(true);
  };

  const sendIO = (IUV) => {
    setSelectedIUV(IUV);
    setShowModalIO(true);
  };

  const handleCloseModal = () => {
    console.log("chiudo la modale");
    setFormData({
      iuv: "",
      descrizione: "",
      valore: 0,
      inviaEmail: true,
    });
    setShowModalDetail(false);
  };

  const bodyDetail = (id) => {
    return (
      <>
        <div className="row mb-lg-3">
          In seguito potrai verificare lo stato del flusso dalla sezione 'Flussi
          MyPay' {id}
        </div>

        <div className="row">
          <input type="hidden" id="Iuv" name="Iuv" value={id} readOnly />

          <div className="col-lg-6">
            <p>
              Inserendo il valore <strong>0</strong> il pagamento verrà
              eliminato!
            </p>
          </div>
          <div className="col-lg-6">
            <label htmlFor="valore">
              Cambia importo
              <input
                id="valore"
                name="valore"
                type="number"
                step="0.01" // Permette i decimali
                value={formData.valore ?? 0} // Imposta un valore numerico di default
                onChange={(e) => {
                  const newValue = e.target.value;
                  if (newValue === "") {
                    setFormData({ ...formData, valore: null }); // Usa null se vuoto
                  } else {
                    setFormData({ ...formData, valore: parseFloat(newValue) });
                  }
                }}
              />
            </label>
          </div>
          <div className="col-lg-12">
            <div>
              <label htmlFor="descrizione">Descrizione:</label>
              <textarea
                id="descrizione"
                name="descrizione"
                value={formData.descrizione}
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="form-check mt-3">
              <input
                id="inviaEmailAnnullamento"
                type="checkbox"
                className="form-check-input"
                checked={formData.inviaEmail !== false}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    inviaEmail: e.target.checked,
                  })
                }
              />
              <label
                className="form-check-label"
                htmlFor="inviaEmailAnnullamento"
              >
                Invia email
              </label>
              <small className="form-text text-muted d-block">
                Se selezionato, il cittadino riceve una comunicazione con IUV,
                importo e descrizione.
              </small>
            </div>

            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione.</b> {error}".
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const handleCloseModalMail = () => {
    console.log("chiudo la modale Mail");

    setShowModalMail(false);
  };

  const bodyMail = (id) => {
    return (
      <>
        <div className="row mb-lg-3">
          Premendo Invia Email, il cittadino riceverà il bollettino PagoPa. Solo
          chi ha fornito un'email registrata riceverà la comunicazione.{" "}
          {props.userId}
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div>
              <label htmlFor="Iuv">Iuv:</label>
              <input type="text" id="Iuv" name="Iuv" value={id} readOnly />
            </div>
            <div></div>
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione.</b> {error}".
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const bodyIO = (iuv) => {
    return (
      <>
        <div className="row mb-lg-3">
          Premendo Invia IO, il cittadino riceverà una notifica sull'App IO con
          pagamento PagoPA. Solo chi l'app installata sul device riceverà la
          notiifca. {props.userId}
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div>
              <label htmlFor="Iuv">Iuv:</label>
              <input type="text" id="Iuv" name="Iuv" value={iuv} readOnly />
            </div>
            <div></div>
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione.</b> {error}".
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="card-wrapper card-space">
        <div className="card card-bg card-big roundedCustom no-after">
          <div className="card-body">
            <div className="row mb-2">
              <div className="col-6">
                <h4>Pagamenti</h4>
              </div>
              <div className="col-6 text-right">
                {!citizen && !delegate && props.userId && (
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm mr-2"
                    title="Crea pagamento MyPay personalizzato"
                    onClick={openCustomPaymentModal}
                  >
                    Pagamento personalizzato
                  </button>
                )}
                {props.showDuePaymentsPdf && (
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    title="Scarica PDF dei pagamenti dovuti"
                    onClick={props.onExportDuePaymentsPdf}
                    disabled={props.exportingDuePdf}
                  >
                    {props.exportingDuePdf
                      ? "PDF in corso..."
                      : "PDF pagamenti dovuti"}
                  </button>
                )}
                {props.goBack && (
                  <button
                    className="btn btn-info ml-2"
                    onClick={() => history.goBack()}
                  >
                    <svg className="icon icon-white icon-sm">
                      <use href={`${iconSprite}#it-arrow-left`} />
                    </svg>
                    <span className="text-white">Indietro</span>
                  </button>
                )}
              </div>
            </div>

            {props.payments?.length > 0 ? (
              props.payments.map((x) => (
                <div
                  key={x.id}
                  className={`payment-card ${
                    x.isPagato ? "border-success" : "border-danger"
                  }`}
                >
                  <div className="row mt-4 ml-3">
                    <div className="col-12">{x.titolo || "Pagamento"} </div>
                    <div className="w-100 sl-h10"></div>

                    <div className="col-lg-5">
                      <div>
                        Importo dovuto:{" "}
                        <span className="fw-semibold">
                          <b>{x.importoDovuto?.toLocaleString("it-IT")} €</b>
                        </span>

                        {x?.ore?.trim() && x.ore.trim() !== "0" && (
                            <span>&nbsp;<i>Ore: {x.ore}</i></span>
                          )}

                      </div>
                      <div>
                        Importo pagato:{" "}
                        <b>
                          {x.isPagato
                            ? `${x.importoTotalePagato?.toLocaleString(
                                "it-IT"
                              )} €`
                            : "0 €"}
                        </b>
                      </div>
                      {!citizen && x?.descrizione && (
                        <span className="badge bg-primary text-white">
                          {x.descrizione}
                        </span>
                      )}
                    </div>

                    <div className="col-lg-4 col-md-3 mb-3">
                      <Badge
                        badgeStatus={
                          x.isPagato && x.importoTotalePagato === 0
                            ? "bg-warning"
                            : x.isPagato
                            ? "bg-success"
                            : "bg-danger"
                        }
                        badgeText={
                          x.isPagato && x.importoTotalePagato === 0
                            ? "Annullato"
                            : x.isPagato
                            ? "Pagato"
                            : "Da pagare"
                        }
                        title={x?.dataEsitoSingoloPagamento}
                      />
                      <Badge
                        badgeStatus={x.isEmailSent ? "bg-success" : "bg-danger"}
                        badgeText={
                          x.isEmailSent ? "Email inviata" : "Email non inviata"
                        }
                        title={x?.dataIsEmailSent}
                      />

                      <Badge
                        badgeStatus={
                          x.ioId && x.ioId !== "-1" ? "bg-success" : "bg-danger"
                        }
                        badgeText={
                          x.ioId && x.ioId !== "-1"
                            ? "IO inviata"
                            : "IO non inviata"
                        }
                      />

                      <div className="shadow-sm  bg-white">
                        IUV: <strong>{x.codIuv}</strong>{" "}
                        {x.isee && (
                          <div className="small text-muted mt-1">
                            ISEE:{" "}
                            {!citizen && x.isee.id ? (
                              <Link
                                to={`/lista_utenti/dati_utente/visualizza_isee?idIsee=${x.isee.id}`}
                              >
                                <strong>
                                  {x.isee.protocollo || x.isee.id}
                                </strong>
                              </Link>
                            ) : (
                              <strong>
                                {x.isee.protocollo || "-"}
                              </strong>
                            )}
                            {x.isee.value != null &&
                              x.isee.value !== undefined && (
                                <>
                                  {" "}
                                  (
                                  {parseFloat(x.isee.value).toLocaleString(
                                    "it-IT",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  )}
                                  &nbsp;€)
                                </>
                              )}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col text-right">
                      {x.isPagato ? (
                        <>
                          <button
                            className="btn btn-outline-primary p-2 mr-2"
                            onClick={() => showPayments(x.codIuv)}
                            aria-label="Visualizza"
                            title="Visualizza"
                          >
                            <svg className="icon icon-primary">
                              <use href={`${iconSprite}#it-file`} />
                            </svg>
                          </button>
                        </>
                      ) : (
                        <>
                          {!citizen && (
                            <>
                              <button
                                className="btn btn-outline-primary p-2 mr-2"
                                onClick={() => showDetail(x.codIuv)}
                                disabled={delegate}
                                title="Dettagli"
                              >
                                <svg className="icon icon-primary">
                                  <use href={`${iconSprite}#it-pencil`} />
                                </svg>
                              </button>

                              <button
                                className="btn btn-outline-primary p-2 mr-2"
                                onClick={() => sendIO(x.codIuv)}
                                disabled={delegate}
                                title={`IO ${x.ioId}`}
                              >
                                <img
                                  src={IO}
                                  alt={`${x.ioId}`}
                                  className="img-io"
                                />
                              </button>

                              <button
                                className="btn btn-outline-primary p-2 mr-2"
                                onClick={() => showPayments(x.codIuv)}
                                aria-label="Visualizza"
                                title="Visualizza"
                              >
                                <svg className="icon icon-primary">
                                  <use href={`${iconSprite}#it-file`} />
                                </svg>
                              </button>
                            </>
                          )}

                          <button
                            className="btn btn-outline-primary p-2"
                            onClick={() => sendPayments(x.codIuv)}
                            title="Invia email"
                          >
                            <svg className="icon icon-primary">
                              <use href={`${iconSprite}#it-mail`} />
                            </svg>
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <>Non ci sono pagamenti</>
            )}

            {props.paymentsTemp && (
              <Pagination
                items={props.paymentsTemp}
                setCurrentItems={props.setPayments}
                itemsPerPage={15}
                pageParam="page"
              />
            )}
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={() => toggleModalShowFile(!showFileToggle)}
        isOpen={showFileToggle}
        header="File"
        body={bodyFile()}
        buttonDeny="Chiudi"
      />

      <ModalComponent
        toggleModal={toggleModalDetail}
        isOpen={showModalDetail}
        header="Dettagli"
        body={bodyDetail(selectedIUV)}
        buttonDeny="Annulla"
        buttonConfirm="Conferma"
        function={handleSave}
        onClose={handleCloseModal}
      />

      <ModalComponent
        labelledBy="modalEmail"
        toggleModal={toggleModalMail}
        isOpen={showModalMail}
        header="Invia email con il bollettino"
        body={bodyMail(selectedIUV)}
        buttonConfirm="Invia email"
        buttonDeny="Annulla"
        function={handleSaveSendMail}
      />

      <ModalComponent
        labelledBy="modalIO"
        toggleModal={toggleModalIO}
        isOpen={showModalIO}
        header="Invia Notifica IO"
        body={bodyIO(selectedIUV)}
        buttonConfirm="Invia notifica IO"
        buttonDeny="Annulla"
        function={handleSaveSendIO}
      />

      <ModalComponent
        labelledBy="modalCustomPayment"
        toggleModal={closeCustomPaymentModal}
        isOpen={showModalCustomPayment}
        header="Pagamento personalizzato MyPay"
        body={bodyCustomPayment()}
        buttonConfirm={
          customPaymentLoading ? "Creazione in corso..." : "Crea pagamento"
        }
        buttonDeny="Annulla"
        function={handleSaveCustomPayment}
        confirmDisabled={customPaymentLoading || !isCustomPaymentFormValid}
      />
    </>
  );
};

export default ListPaymemtsUsers;
